import TopMoversTable from './TopMoversTable';
export default TopMoversTable;
